import React, { useEffect } from "react";
import UserSidebar from "../../Component/UserSidebar";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as settingActions from "../../actions/settingActions";
import * as baseActions from "../../actions/baseActions";
import StudentSignup from "./UpdateProfileStep12";
import PropTypes from "prop-types";


function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}
function SidebarRemoveClass() {
  document.getElementById("OnscrollBody").classList.remove("show_sidebar");
}

const UpdateProfile1 = (props) => {
  const { title, setting } = props;

  useEffect(() => {
    document.title = title
  }, [title]);

  const moduleRenderData = setting?.module_data

  const isSectionShow = (name) => {
    return moduleRenderData?.some((item) => item?.name == name && item?.status == "Enabled" && item?.is_default == "Yes")
  }

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />

        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>

          <h1 className="dash_heading mb-3">Complete/ Edit Profile</h1>

          <div className="box shadow bg-white p-4">
            {setting?.is_sso_enable !== "1" && isSectionShow('Change Password') && (
              <div className="changepassword text-end">
                <Link to="/change-password" className="btn">
                  Change Password
                </Link>
              </div>
            )}
            <div className="studentformdashboard">
              <StudentSignup type='profile' />
            </div>
          </div>
        </div>
      </div >
      <input
        type="button"
        className="sidebar_overlay"
        onClick={SidebarRemoveClass}
        aria-label="Close sidebar overlay"
      />
    </div >
  );
};

function mapStateToProps(state) {
  return {
    setting: state.setting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...settingActions,
        ...baseActions
      },

      dispatch
    ),
  };
}
UpdateProfile1.propTypes = {
  title: PropTypes.string,
  setting: PropTypes.shape({
    is_sso_enable: PropTypes.string,
    module_data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        status: PropTypes.string,
        is_default: PropTypes.string,
      })
    ),
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProfile1);

